import { useCallback, useState } from 'react';
import useModal from 'src/components/Modals/hooks/useModal';
import { FeatureAnnouncement } from 'src/constants/featureAnnouncements';
import useFeatureAnnouncementGlobalState from 'src/components/FeatureAnnouncementTrigger/hooks/useFeatureAnnouncementGlobalState';
import { getFeatureAnnouncementLocalStorageKey } from 'src/components/FeatureAnnouncementTrigger/utils';
import useFeatureAnnouncementTriggerSideEffects from 'src/components/FeatureAnnouncementTrigger/hooks/useFeatureAnnouncementTriggerSideEffects';

export default function useFeatureAnnouncementTrigger() {
	const { show } = useModal();
	const [popoverOpen, setPopoverOpen] = useState(false);

	const [{ announcements, unseenCount }, setFeatureAnnouncementGlobalState] =
		useFeatureAnnouncementGlobalState();

	useFeatureAnnouncementTriggerSideEffects({ unseenCount });

	const hasSeenAnnouncement = useCallback(
		(announcement: FeatureAnnouncement) => {
			if (typeof window === 'undefined') {
				return false;
			}

			const key = getFeatureAnnouncementLocalStorageKey(announcement);
			const res = localStorage.getItem(key);
			return res === 'true';
		},
		[]
	);

	const setHasSeenAnnouncement = useCallback(
		(announcement: FeatureAnnouncement) => {
			setFeatureAnnouncementGlobalState((prev) => {
				if (prev.unseenCount === 0) {
					return prev;
				}

				return {
					...prev,
					unseenCount: prev.unseenCount - 1,
				};
			});

			const key = getFeatureAnnouncementLocalStorageKey(announcement);

			localStorage.setItem(key, 'true');
		},
		[]
	);

	const showFeatureAnnouncementModal = useCallback(
		(announcement: FeatureAnnouncement) => {
			setPopoverOpen(false);

			show({
				type: 'feature_announcement',
				props: { announcementName: announcement.name },
			});

			setHasSeenAnnouncement(announcement);
		},
		[show]
	);

	return {
		popoverOpen,
		setPopoverOpen,
		announcements,
		unseenCount,
		hasSeenAnnouncement,
		showFeatureAnnouncementModal,
	};
}
